import { Component, Input, ViewChild, ElementRef, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule, formatDate } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import {
    MatDialog,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';

import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, map } from 'rxjs/operators';
import { of, interval } from 'rxjs';
import SignaturePad from 'signature_pad';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { GlobalService } from '../../global.service';
import { AjaxService } from '../../ajax.service';
import { UploadService } from '../../upload.service';

// Form base component for dynamic form rendering
@Component({
    selector: 'app-formbase',
    standalone: false,
    templateUrl: './formbase.component.html',
    styleUrls: ['./formbase.component.scss']
})
export class FormBaseComponent {
    @Input() formnr: string;
    @Input() ordnr: string;

    readonly dialog = inject(MatDialog);
    formID: number = null; // het geselecteerde formulier (de template)
    formHdr: number = null; // de geselecteerde antwoordgroep
    formDisable = false;
    formQuestions = []; // vragenlijst
    formulier = [];
    public writingJobs = false;
    signatureQ = -1;
    signaturePad: SignaturePad;
    @ViewChild('signpad', { static: false }) signaturePadElt: ElementRef;
    imgs = [];
    idx = 0; // index van de foto in de lijst
    imgsLoading = false;
    @ViewChild('fileUpload', { static: false }) fileUpload: ElementRef;
    files = [];
    uploading = false;
    nrUploadFiles = 0;
    UploadProgress = 0;
    UploadedFiles = 0;
    subscription1: any; // interval subscription
    subscription2: any; // interval subscription
    now = 0;

    constructor(
        public global: GlobalService,
        private ajax: AjaxService,
        private uploadService: UploadService,
        private snackBar: MatSnackBar,
    ) {
    }

    ngOnInit() {
        if (this.formnr.substring(0, 3) === 'NEW') {
            // nieuw aan te maken formulier
            this.ordnr = this.ordnr;
        } else {
            // bestaand formulier
            this.ordnr = '';
        }
        // console.log("ngOnInit", this.formnr, this.formHdr, this.ordnr);

        this.ajax.get('f3/api/form/getForm', {
            hdrID: this.formnr,
            ordNr: this.ordnr
        }).then((data: any) => {
            console.log('getForm', data);
            if (!data) {
                this.snackBar.open('Geen communicatie met server!', 'OK', {
                    duration: 3000
                });
            }
            this.formulier = data;
            this.formHdr = this.formulier['header']['id'];
            this.formID = this.formulier['header']['formId'];
            this.ordnr = this.formulier['header']['LiproNr'];
            this.chForm();
            this.loadImgs();

            setTimeout(() => {
                if (this.signaturePadElt) {
                    this.signaturePad = new SignaturePad(this.signaturePadElt.nativeElement);
                    console.log('===== signaturepad initialized.');
                } else {
                    console.log('===== no canvas found');
                }
            },
                1000
            );

            const observable = interval(2000);
            this.subscription1 = observable.subscribe(x => this.saveAnswers());

            const setTimer = interval(500);
            this.subscription2 = setTimer.subscribe(x => this.now = Date.now());
        });
    }

    // set up form questions
    chForm() {
        this.formQuestions = this.formulier['vragen'];
        var qi = 0;
        this.signatureQ = -1;
        for (const q of this.formQuestions) {
            q.hideSaveIcon = 0;
            let a = this.formulier['antwoorden'].find(i => i.fvVar === q.fvVar);
            if (a) {
                if (q.fvTyp === 'M') {
                    try {
                        q.value = JSON.parse(a.value);
                    } catch (e) {
                        console.error('Error parsing JSON:', e);
                        q.value = '';
                    }
                } else {
                    q.value = a.value;
                }
                q.oldval = q.value;
                q.fvDDT = a.fvDDT;
                q.fvDDTmod = a.fvDDT;
                if (q.fvTyp === 'S' && q.value) {
                    this.formDisable = true;
                }
            } else {
                if (q.fvTyp === 'N') {
                    const x = q.fvDef.split(';');
                    if (x) {
                        q.value = x[0];
                        q.fvDDT = 1;
                        if (x.length > 1) {
                            // set FormControl min value  --> zie https://angular.io/guide/form-validation
                        }
                    }
                } else {
                    if ('fvDefault' in q) {
                        if (q.fvTyp === 'M') {
                            try {
                                q.value = JSON.parse(q.fvDefault);
                            } catch (e) {
                                console.error('Error parsing JSON M-default:', e);
                                q.value = '';
                            }
                        } else {
                            q.value = q.fvDefault;
                        }
                        q.fvDDT = 0;
                        q.fvDDTmod = 1;
                    } else {
                        q.value = ''; // hier komt het invul-antwoord
                        q.fvDDT = 0; // tijdstip waarde
                        q.fvDDTmod = 0; // tijdstip waarde, locaal gewijzigd
                    }
                }
            }
            q.showHelp = false;
            q.visible = true;
            q.fvHelp = q.fvHelp.replace(/\r?\n|\r/g, '<br>');
            if (q.fvTek) {
                const imgurl = this.global.baseurl + '/api/img.php'
                    + '?compname=' + this.global.compname
                    + '&username=' + this.global.username
                    + '&password=' + this.global.password
                    + '&session=' + this.global.session
                    + '&f=fvTek'
                    + '&t=form_vragen'
                    + '&i=fvID'
                    + '&v=' + q.fvID
                    ;
                q.fvHelp +=
                    '<img src="' + imgurl + '" align="right"' +
                    ' style="height: 200px; width: 200px; object-fit: contain;">';
            }

            if (q.fvRes == 'False' || q.fvRes == 'True') {
                q.fvRes = q.fvRes.toLowerCase();
            }

            // verwerking parameters fvTyp
            if (q.fvTyp === 'L' || q.fvTyp === 'M') {
                q.choices = [];
                q.fvDef.split(/[;\n]/).forEach(ch => {
                    ch = ch.trim();
                    const x = ch.split('=', 2);
                    if (x.length === 2) {
                        q.choices.push({
                            ID: x[0],
                            txt: x[1]
                        });
                    } else if (x.length === 1) {
                        q.choices.push({
                            ID: x[0],
                            txt: x[0]
                        });
                    }
                });
            }
            if (q.fvTyp === 'S') {
                this.signatureQ = qi;
                console.log('signatureQ:', this.signatureQ);
            }
            qi++;
        }
        this.evalForm();
    }

    /**
     * Antwoorden ophalen zodat deze in evaluatie gebruikt kunnen worden
     * @returns string met alle antwoorden in de vorm van variabelen
     */
    getAnswersList() {
        let answers = '';
        for (const q of this.formQuestions) {
            if (q.fvVar) {
                if (typeof q.value === 'string') {
                    q.value = q.value.replace(/'/gm, "’");
                }
                let val =
                    (q.fvTyp === 'DATE') ?
                        (q.value) ? `'` + formatDate(q.value, 'yyyy-MM-dd', 'en-US') + `'` : `'0000-00-00'`
                        : (typeof q.value === 'string') && (q.fvTyp !== 'N') ? `'${q.value}'`
                            : (q.value) ? q.value
                                : 'null';
                if ((typeof q.value === 'string') && (q.fvTyp !== 'N')) {
                    val = val.replace(/[\r\n]+/gm, " ");
                }
                if (q.fvTyp === 'M') {
                    // voor M-velden, JSON.stringify gebruiken
                    val = JSON.stringify(q.value);
                }
                answers = answers + `let ${q.fvVar}=${val}; `; // hier komt het invul-antwoord
                q.val = val;
            }
        }
        return answers;
    }

    evalForm() {
        let answers = this.getAnswersList();

        for (const q of this.formQuestions) {
            if (q.fvTyp === 'F') { // formules herberekenen
                const cmd = `(function() { let _retv = true; ${answers} _retv=(${q.fvDef}); return _retv; })();`;
                let newval = 0;
                try {
                    newval = eval(cmd);
                } catch (err) {
                    console.error(err, 'cmd=', cmd);
                }
                q.value = newval;
            }
        }

        // evt onChange functies uitvoeren
        for (const q of this.formQuestions) {
            if (q.fvVar) {
                if (q.oldval !== q.value) {
                    console.log('onChange:', q.fvOnChange, q.value, q.oldval);
                    q.fvDDTmod = Date.now();
                    q.hideSaveIcon = 0;
                    console.log('mod status = ', q.fvDDTmod, q.fvDDT, q.value);
                    if (q.fvOnChange) {
                        const cmd = `(function() { let _retv = true; ${answers} _retv=(${q.fvOnChange}); return _retv; })();`;
                        try {
                            // tslint:disable-next-line: no-eval
                            let toModify = eval(cmd);
                            console.log('result onChange:', toModify);
                            if (toModify) {
                                let modlist = toModify.split(';');
                                for (let mod of modlist) {
                                    let modparts = mod.split('=');
                                    if (modparts.length === 2) {
                                        let q = this.formQuestions.find(q => q.fvVar === modparts[0]);
                                        if (q) {
                                            q.value = modparts[1];
                                            q.fvDDTmod = Date.now();
                                            q.hideSaveIcon = 0;
                                            console.log('mod status = ', q.fvDDTmod, q.fvDDT, q.value);
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            console.log('cmd=', cmd);
                            console.error(err);
                        }
                    }
                    q.oldval = q.value;
                }
            }
        }
        answers = this.getAnswersList(); // opnieuw, want er kunnen wijzigingen zijn

        for (const { i, q } of this.formQuestions.map((q, i) => ({ i, q }))) {
            let test = true;
            let msg = '';
            if (q.fvRes.length > 0) {
                const cmd = `(function() { let _retv = true; ${answers} _retv=(${q.fvRes}); return _retv; })();`;
                try {
                    // tslint:disable-next-line: no-eval
                    test = eval(cmd);
                } catch (err) {
                    console.log('cmd=', cmd);
                    console.error(err);
                }
            }
            if (q.fvChk.length > 0) {
                const cmd = `(function() { let _retv = true; ${answers} _retv=(${q.fvChk}); return _retv; })();`;
                try {
                    // tslint:disable-next-line: no-eval
                    msg = eval(cmd);
                } catch (err) {
                    console.log('cmd=', cmd);
                    console.error(err);
                }
            }
            this.formQuestions[i].visible = test; // hier komt het invul-antwoord
            this.formQuestions[i].msg = msg; // hier komt het invul-antwoord
            console.log('msg:', msg);
        }
        console.log('evalForm', this.formQuestions);
    }

    /**
     * Alle gewijzigde antwoorden opslaan (methode 2024-12)
     */
    saveAnswers() {
        let toSave = [];
        for (const q of this.formQuestions) {
            if (q.fvVar && q.fvDDTmod > q.fvDDT) {
                // answer to be saved
                toSave.push({
                    hdrID: this.formHdr,
                    fvRev: this.formulier['header']['rev'],
                    fvVar: q.fvVar,
                    value: (q.fvTyp === 'DATE')
                        ? (q.value) ? formatDate(q.value, 'yyyy-MM-dd', 'en-US') : '0000-00-00'
                        : (q.fvTyp === 'M')
                            ? JSON.stringify(q.value)
                            : q.value,
                    fvDDT: q.fvDDTmod
                });
            }
        }
        if (toSave.length > 0) {
            console.log('to be saved:', toSave);
            this.ajax.get('f3/api/form/saveAnswers', {
                answers: toSave
            }).then((data: any) => {
                console.log('saveAnswers', data);
                if (data && data['saved']) {
                    for (const qq of data['saved']) {
                        const q = this.formQuestions.find(q => q.fvVar === qq.fvVar);
                        if (q) {
                            q.fvDDT = qq.fvDDT;
                            q.hideSaveIcon = Date.now() + 2000;
                        }
                    }
                }
            });
        }
    }

    save() {
        let promises = [];
        this.snackBar.open('Formulier wordt opgeslagen ...');
        for (const q of this.formQuestions) {
            this.writingJobs = true;
            if (q.fvTyp === 'S') {
                // alleen de handtekening nog op oude manier opslaan
                q.value = this.signaturePad.toDataURL();
                let toSave = [];
                toSave.push({
                    hdrID: this.formHdr,
                    fvVar: q.fvVar,
                    value: q.value,
                    fvDDT: Date.now(),
                    fvRev: this.formulier['header']['rev'],
                });
                promises.push(this.ajax.get('f3/api/form/saveAnswers', {
                    answers: toSave
                }));
            }
        }

        if (!this.formDisable) {
            const tz = new Date();
            const offset = tz.getTimezoneOffset();
            const localDate = new Date(tz.getTime() - (offset * 60 * 1000));
            const today = localDate.toISOString().split('T')[0];
            console.log('Today is ', today);

            promises.push(this.ajax.get('updateRecord', {
                table: 'form_hdr',
                where: `id='${this.formHdr}'`,
                fields: {
                    vastgelegd: today
                }
            }));
            this.formDisable = true;
        }

        Promise.all(promises).then(() => {
            // alle waarden zijn opgeslagen --> document aanmaken/mailen
            this.ajax.get('formulierSubmit', {
                hdrID: this.formHdr,
            }).then((data: any) => {
                console.log('formulierSubmit', data);
                this.writingJobs = false;
                this.snackBar.open('Formulier is opgeslagen.', 'OK', {
                    duration: 3000
                });
            }, (err) => {
                console.log('formulierSubmit error', err);
                this.writingJobs = false;
                this.snackBar.open('Probleem bij opslaan formulier!', 'OK', {
                    duration: 3000
                });
            });
        });
    }

    drawStart() {
        console.log('draw start');
    }

    drawEnd(qnr) {
        console.log('draw end');
        this.formQuestions[qnr].value = this.signaturePad.toDataURL();
    }

    drawClear() {
        this.signaturePad.clear();
    }

    initSig() {
        if (this.signaturePadElt) {
            this.signaturePad = new SignaturePad(this.signaturePadElt.nativeElement);
            console.log('===== signaturepad initialized.');
        } else {
            console.log('===== no canvas found');
        }
    }

    loadImgs() {
        this.imgs = [];
        this.imgsLoading = true;
        this.ajax.get('getDocs', {
            table: 'orders',
            value: this.ordnr,
            subdir: '/form-' + this.formHdr
        }).then((data: any) => {
            console.log('loadImgs', data);
            this.imgs = (data.result) ? data.result.Imgs : data.Imgs; // data.result is voor compatibiliteit met lisaas-ng
            this.imgsLoading = false;
        });
    }

    /**
     * Opslaan text bij foto
     * @param i Positie foto in this.imgs[i]
     * Automatisch aangeroepen vanuit HTML code na wijziging van de tekst
     */
    saveTxt(i) {
        console.log('form-saveTxt:', this.ordnr, '/form-' + this.formHdr, this.imgs[i].filename);
        this.ajax.get('setDocTxt', {
            table: 'orders',
            value: this.ordnr,
            subdir: '/form-' + this.formHdr,
            filename: this.imgs[i].filename,
            txt: this.imgs[i].txt
        });
    }

    /**
     * on click 'upload' foto's
     */
    doUpload() {
        this.files = [];
        const fileUpload = this.fileUpload.nativeElement;
        fileUpload.onchange = () => {
            this.uploading = true;
            for (const file of fileUpload.files) {
                this.files.push({ data: file, inProgress: false, progress: 0 });
            }
            this.fileUpload.nativeElement.value = '';
            this.nrUploadFiles = this.files.length;
            console.log('uploading', this.nrUploadFiles, this.files);
            this.files.forEach(file => {
                this.uploadFile(file);
            });
        };
        fileUpload.click();
    }

    uploadFile(file) {
        const formData = new FormData();
        formData.append('comp', this.global.compname);
        formData.append('usr', this.global.username);
        formData.append('pwd', this.global.password);
        formData.append('ses', this.global.session);
        formData.append('val', this.ordnr);
        formData.append('sub', 'form-' + this.formHdr);
        formData.append('file', file.data);
        file.inProgress = true;

        this.uploadService.upload(formData).pipe(
            map(event => {
                switch (event.type) {
                    case HttpEventType.UploadProgress:
                        file.progress = Math.round(event.loaded * 100 / event.total);
                        break;
                    case HttpEventType.Response:
                        return event;
                }
            }),
            catchError((error: HttpErrorResponse) => {
                file.inProgress = false;
                return of(`${file.data.name} upload failed.`);
            })
        ).subscribe((event: any) => {
            if (typeof (event) === 'object') {
                file.inProgress = false;
                let busy = false;
                let done = 0;
                for (const afile of this.files) {
                    busy = busy || afile.inProgress;
                    if (!afile.inProgress) { done++ };
                }
                this.UploadedFiles = done;
                this.UploadProgress = Math.round(this.UploadedFiles * 100 / this.nrUploadFiles);
                if (!busy) {
                    this.uploading = false;
                    this.files = [];
                    this.loadImgs();
                }
            }
        });
    }

    dlgDelFoto(i: number, enterAnimationDuration: string = '0ms', exitAnimationDuration: string = '0ms'): void {
        const dialogRef = this.dialog.open(DialogDelFoto, {
            width: '350px',
            enterAnimationDuration,
            exitAnimationDuration,
            data: {
                filename: this.imgs[i]?.filename,
                index: i
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('Dialog result:', result);
            if (result === 'delete') {
                this.delFoto(i);
            }
            // Add other actions based on result if needed
        });
    }

    delFoto(i) {
        console.log('delFoto:', this.ordnr, '/form-' + this.formHdr, this.imgs[i].filename);

        this.ajax.get('delFile', {
            table: 'orders',
            value: this.ordnr,
            subdir: '/form-' + this.formHdr,
            fname: this.imgs[i].filename + '.txt',
        }).then((data: any) => {
            console.log('Delete file result:', data);
        }).catch((error) => {
            // console.error('Error deleting file:', error);
        });

        this.ajax.get('delFile', {
            table: 'orders',
            value: this.ordnr,
            subdir: '/form-' + this.formHdr,
            fname: this.imgs[i].filename,
        }).then((data: any) => {
            console.log('Delete file result:', data);
            this.loadImgs(); // Reload images after deletion
            this.snackBar.open('Foto verwijderd', 'OK', {
                duration: 2000
            });
        }).catch((error) => {
            console.error('Error deleting file:', error);
            this.snackBar.open('Fout bij verwijderen foto', 'OK', {
                duration: 3000
            });
        });
    }

    initForm(params) {
        this.formHdr = params.formnr;
        if (params.formnr.substr(0, 3) === 'NEW') {
            // nieuw aan te maken formulier
            this.ordnr = params.ordnr;
        } else {
            // bestaand formulier
            this.ordnr = '';
        }
        // console.log("initForm", this.formHdr, this.ordnr);
        this.ajax.get('f3/api/form/getForm', {
            hdrID: this.formHdr,
            ordNr: this.ordnr
        }).then((data: any) => {
            console.log('getForm', data);
            if (!data) {
                this.snackBar.open('Geen communicatie met server!', 'OK', {
                    duration: 3000
                });
            }
            this.formulier = data;
            this.formHdr = this.formulier['header']['id'];
            this.formID = this.formulier['header']['formId'];
            this.ordnr = this.formulier['header']['LiproNr'];
            this.chForm();
            this.loadImgs();

            setTimeout(this.initSig, 1000);

            const observable = interval(2000);
            this.subscription1 = observable.subscribe(x => this.saveAnswers());

            const setTimer = interval(500);
            this.subscription2 = setTimer.subscribe(x => this.now = Date.now());
        });
    }

    ionViewWillLeave() {
        this.subscription1.unsubscribe();
        this.subscription2.unsubscribe();
    }
}

@Component({
  selector: 'dialog-animations-example-dialog',
  templateUrl: 'dlgDelFoto.html',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogActions, MatDialogTitle, MatDialogContent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogDelFoto {
  readonly dialogRef = inject(MatDialogRef<DialogDelFoto>);
  readonly data = inject(MAT_DIALOG_DATA);

  onDeleteClick(): void {
    this.dialogRef.close('delete');
  }

  onCancelClick(): void {
    this.dialogRef.close('cancel');
  }
}
